export function IconNumberSquare() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9091 2.5H2.09091C1.76456 2.5 1.5 2.72386 1.5 3V13C1.5 13.2761 1.76456 13.5 2.09091 13.5H13.9091C14.2354 13.5 14.5 13.2761 14.5 13V3C14.5 2.72386 14.2354 2.5 13.9091 2.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0125 7.875L5 11.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 8.75C6.4665 8.75 7.25 7.9665 7.25 7C7.25 6.0335 6.4665 5.25 5.5 5.25C4.5335 5.25 3.75 6.0335 3.75 7C3.75 7.9665 4.5335 8.75 5.5 8.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9873 8.375L10.9998 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11C11.4665 11 12.25 10.2165 12.25 9.25C12.25 8.2835 11.4665 7.5 10.5 7.5C9.5335 7.5 8.75 8.2835 8.75 9.25C8.75 10.2165 9.5335 11 10.5 11Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
